import { mapAxiosResponse } from '../../shared/utils/api-utils';
import { ChatMessage } from '../../shared/models/chat';
import ErcApiClient from '../../shared/services/erc-api-client';

export default class ChatService {
  static async loadMessages(chatChannel: string): Promise<ChatMessage[]> {
    const resp = await ErcApiClient.get(`/curbside/messages/${chatChannel}`);

    return mapAxiosResponse<ChatMessage[]>(resp);
  }

  static async sendMessage(chatChannel: string, message: ChatMessage, inviteCode: string): Promise<ChatMessage> {
    const resp = await ErcApiClient.post(`/curbside/messages/${chatChannel}`, { message, inviteCode, type: 'delivery' });

    return mapAxiosResponse<ChatMessage>(resp);
  }
}
